module.exports = __webpack_public_path__ + "static/media/download-apps-phone.cce3f794.webp";